import type { ApplicationState } from '..';

export const selectIsAuthenticationCallbackDone = (state: ApplicationState) =>
  state.authentication.isAuthenticationCallbackDone;
